import {APIService} from '@/services/api.service';
import {IProblem, Price} from '@mobi-components/global-solution';
import {SolutionResponse} from '../solution/solution-support.types';
import {IDomainCategoryDescription} from '../state/global.types';
import {Trip} from './download-destination-trips';
import {TravelersIndormation} from './submit-amex-problem';

export interface TripSelectionProgress {
  candidate_trips: Trip[];
  selected_filters: IDomainCategoryDescription[];
  traveler_information: TravelersIndormation;
  budget: {price: Price[]};
}

export interface SolutionWithProblem {
  problem: IProblem;
  solution_response: SolutionResponse;
  selected_filters: IDomainCategoryDescription[];
}

export async function getSelectedTrips(tripId: string, userId: string): Promise<TripSelectionProgress | null> {
  if (!tripId) {
    return null;
  }
  try {
    const {progress} = await APIService.get<{progress: TripSelectionProgress}>('progress', {
      params: {
        user_id: userId,
        selected_trip_id: tripId,
      },
    });
    return progress;
  } catch {
    return null;
  }
}
